import { connect } from 'react-redux';
import { lifecycle, compose, withState, withHandlers } from 'recompose';
import ImageLibraryTable from '../components/ImageLibraryTable';

import { store } from 'store/createStore';
import { open } from 'store/modules/modal';
import API from '../../../../utils/api';

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

const enhance = compose(
  connect(mapStateToProps),
  withState('imageList', 'setImageList', []),
  withState('countImages', 'setCountImages', 0),
  withState('imagePage', 'setImagePage', 0),
  withState('imagePageSize', 'setImagePageSize', 10),
  withState('imageOrderBy', 'setImageOrderBy', '-createdAt'),
  withState('updateN', 'setUpdateN', 0),
  withState('apiSelected', 'setApiSelected', null),
  withState('teamSelected', 'setTeamSelected', null),

  withHandlers({
    fetchImageList: props => (orderBy, league, team) => {
      const { currentGroup } = store.getState().auth;
      API.getImagesTable({
        page: props.imagePage + 1,
        pageSize: props.imagePageSize,
        query: `{"group":"${currentGroup._id}"}`,
        sort: orderBy ? orderBy : props.imageOrderBy,
        leagueId: league,
        team,
      }).then(({ docs, total }) => {
        props.setImageList(docs);
        props.setCountImages(total);
      });
    },
  }),
  withHandlers({
    onChangeImagePage: props => (_event, page) => {
      props.setImagePage(page, () => {
        props.fetchImageList();
      });
    },
    onChangeRowsPerImagePage: props => event => {
      props.setImagePageSize(event.target.value, () => {
        props.fetchImageList();
      });
    },
    confirmDelete: props => (id, fileName) => {
      props.dispatch(
        open({
          modalType: 'confirm',
          modalProps: {
            message: `This will delete the image '${fileName}', do you want to proceed?`,
            keyId: id,
            handleYes: () => {
              API.deleteImageLibrary(id)
                .then(() => {
                  props.fetchImageList();
                })
                .catch(err => {
                  console.log(err);
                });
            },
          },
        })
      );
    },
    updateSort: props => (sortBy, leagueId, team) => {
      let newSort;

      switch (sortBy) {
        case 'fileName':
          if (props.imageOrderBy === 'fileName') {
            newSort = '-fileName';
          } else {
            newSort = 'fileName';
          }
          break;
        case 'metadata.leagueName':
          if (props.imageOrderBy === 'metadata.leagueName') {
            newSort = '-metadata.leagueName';
          } else {
            newSort = 'metadata.leagueName';
          }
          break;
        case 'metadata.teamName':
          if (props.imageOrderBy === 'metadata.teamName') {
            newSort = '-metadata.teamName';
          } else {
            newSort = 'metadata.teamName';
          }
          break;
        case 'createdAt':
          if (props.imageOrderBy === 'createdAt') {
            newSort = '-createdAt';
          } else {
            newSort = 'createdAt';
          }
          break;
        default:
          newSort = '-createdAt';
      }

      props.setImageOrderBy(newSort);

      props.fetchImageList(newSort, leagueId, team);
    },
  }),
  lifecycle({
    componentDidMount() {
      console.log(this.props);
      this.props.fetchImageList();
    },
    componentDidUpdate(nextProps) {
      const { updateNumber, leagueId, team } = this.props;
      if (
        nextProps.updateN !== updateNumber ||
        (nextProps.updateN !== updateNumber && updateNumber === 0)
      ) {
        nextProps.setUpdateN(updateNumber);
        this.props.fetchImageList(
          nextProps.imageOrderBy,
          nextProps.apiSelected,
          nextProps.teamSelected
        );
      }

      if (
        nextProps.apiSelected !== leagueId ||
        nextProps.teamSelected !== team
      ) {
        this.props.fetchImageList(nextProps.imageOrderBy, leagueId, team);
        nextProps.setApiSelected(leagueId);
        nextProps.setTeamSelected(team);
      }
    },
  })
);

export default enhance(ImageLibraryTable);
